import { Directive, ElementRef, Input } from "@angular/core";
import * as Inputmask from 'inputmask';

@Directive({
    selector: "[regex]"
})
export class RegExInputDirective {
    constructor(private element: ElementRef) { }

    @Input('regex')
    public set defineRegex(regEx: string) {
        Inputmask({ regex: regEx, placeholder: '' })
            .mask(this.element.nativeElement);
    }
}